import CharterCruisingAreas from './CharterCruisingAreas';

export default CharterCruisingAreas;
